import React from 'react'
import { Link, Typography, Stack } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useTranslation } from '../../hooks/helper/useTranslation'

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.common.white,
  },
}))

export const Contact: React.FC = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Stack direction="row" gap={2}>
      <Stack>
        <Typography variant="h6" mb={1}>
          {t('footer:contact.title')}
        </Typography>

        <Link
          className={classes.link}
          href={`mailto:${t('footer:contact.email')}`}
          underline="hover"
          target="_blank"
        >
          <Typography variant="body2">{t('footer:contact.email')}</Typography>
        </Link>
      </Stack>
    </Stack>
  )
}
